import { usePermission } from "./PermissionProvider";

const filterSidebar = (menu) => {
    const {data} = usePermission()
  const userDetail = JSON.parse(localStorage.getItem("userDetail"));
  return menu
    .filter((item) => {
      if (item?.roles) {
        return item?.roles.includes(userDetail?.role);
      }
      return true;
    })
    .map((value) => {
        // console.log(value)
      return value;
    });
};

export default filterSidebar;
